interface DecodedToken {
  exp?: number;
  /** Email claim — the identity the backend stamps as `labeled_by` on saved labels. */
  email?: string;
  allowed_cohorts?: string[];
  user_type?: string;
  company_id?: string;
  /** Granted action capabilities (e.g. "upload"). Internal staff pass gates
   *  implicitly and carry an empty list. */
  capabilities?: string[];
}

/**
 * Decode JWT token payload
 */
export const decodeToken = (token: string): DecodedToken | null => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  // Local dev mode uses a sentinel token that never expires
  if (token === "local-dev") return false;

  try {
    const decoded = decodeToken(token);
    if (!decoded?.exp) return true;

    // Add 30 second buffer before expiration
    return decoded.exp * 1000 <= Date.now() + 30000;
  } catch {
    return true;
  }
};
